export const styles = {
  wrapper: {
    '& .SearchAndFilters': {
      paddingLeft: '40px',
    },
    '& table': {
      marginLeft: '-25px',
    },
    '& .Pagination': {
      marginLeft: '40px',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
  },
}
